export const PODCASTER_SESSION_ID = 'podcaster-session-id';
export const SESSION_ID = 'session-id';
export const UNIQUE_BROWSER_ID = 'ubid-main';
